module.exports = __webpack_public_path__ + "img/active-milestone-glow.7c62ad8f.png";